<template>
  <router-view />
</template>
<script>
export default {
  created(){
    // document.cookie="user_id=123456";
    // let user_id = document.cookie.user_id;
    // console.log(user_id)
  }
};
</script>
<style lang="less">
#app{
  width: 100%;
  height: 100%;
}
</style>
